import '../../common/bn-flash';
import '../../common/bn-loading';
import { sharedStyles } from '../../styles/shared-styles';
import { css, html, LitEntity, SirenActionMixin, renderIf } from '../../utility/lit-entity';

class LocationReschedule extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.actionName = 'update-scheduled-for';
  }

  static get properties() {
    return {
      scheduledFor: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .actions {
        padding: 1em;
      }
      bn-form-field {
        max-width: 12rem;
        display: block;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      <p class="subdued">
        Select a new scheduled for date.
      </p>
      <div>
        <bn-form-field
          title="Scheduled For"
          name="scheduled-for"
          type="date"
          @input="${(e) => this.scheduledFor = e.target.input.value}"
          .value="${this.scheduledFor}"
          required
        ></bn-form-field>
      </div>
      <bn-flash></bn-flash>
      <div class="actions well">
        <button class="button button--contained" @click="${this._submitAction}" ?disabled="${!this.scheduledFor}">
          Reschedule Work Order Location
        </button>
        ${renderIf(this.selectedUser, () => html`to <span class="target-user">${this.selectedUser.properties.name}</span>`)}
      </div>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const action = this.entity.getAction(this.actionName);
    this.scheduledFor = action.getField('scheduledFor').value;
  }

  async _submitAction() {
    const action = this.entity.getAction(this.actionName);
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    try {
      if (!action) {
        throw new Error(`Could not find [${this.actionName}] action`);
      }
      action.getField('scheduledFor').value = this.scheduledFor;
      this.dispatchEvent(new CustomEvent('submit', { bubbles: true, composed: true }));
      const { entity, response, error } = await this.submitAction(action);
      if (error) {
        throw new Error(error);
      }
      flash && flash.success(this.successtext || 'Success.');
      this.dispatchEvent(new CustomEvent('response', { detail: { entity, response }, bubbles: true, composed: true }));
    } catch (error) {
      flash && flash.critical(html`${this.errortext}<div><code>${error.message}</code></div>`);
      this.dispatchEvent(new ErrorEvent('error', { error, bubbles: true, composed: true }));
    }
  }
}

window.customElements.define('location-reschedule', LocationReschedule);
